import React from "react";
import { cardThemes } from "./StatsCard.data";
import FilterSelect from "./FilterSelect";

const VolumeSection = ({ selects = [], cards = [], onClearFilters, showClearButton = false }) => {
  return (
    <div className="container">
      <div className="rounded-md shadow border-gray-200 bg-white p-6">
        {selects.length > 0 && (
          <div className="mb-6 flex flex-wrap items-end gap-4">
            {selects.map((select) => (
              <FilterSelect key={select.id} {...select} className="flex flex-1 min-w-[200px] flex-col gap-1" />
            ))}
            {showClearButton && (
              <button
                type="button"
                onClick={onClearFilters}
                className="h-11 shrink-0 rounded-md border border-[#C8CED8] bg-white px-4 text-sm font-semibold text-[#1A2B49] hover:bg-gray-50"
              >
                Limpar filtros
              </button>
            )}
          </div>
        )}

        <div
          className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(220px,1fr))] min-[800px]:[grid-template-columns:repeat(var(--cards-count),minmax(0,1fr))]"
          style={{ "--cards-count": cards.length || 4 }}
        >
          {cards.map((card) => (
            <article
              key={card.title}
              className={`flex min-h-[120px] w-full flex-col items-center justify-center rounded-md px-4 py-3 text-center ${
                cardThemes[card.color] || cardThemes.navy
              }`}
            >
              <p className="mb-2 text-[clamp(0.75rem,1vw,0.875rem)] font-bold leading-tight">
                {card.title}
              </p>
              <h3 className="break-words text-[clamp(1.375rem,2.4vw,1.5625rem)] font-bold leading-none">
                {card.value}
              </h3>
              {!!card.subtitle && (
                <span className="mt-2 text-[clamp(0.8125rem,1.05vw,0.9375rem)] font-semibold">
                  {card.subtitle}
                </span>
              )}
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(VolumeSection);
